export default {
  name: 'clickCollectDeliverySelector',
  component() {
    return {
      init() {
        if (this.$store.clickCollect) {
          this.$store.clickCollect.init();
        }
      },

      get deliveryMethod() {
        return this.$store.clickCollect?.deliveryMethod || 'delivery';
      },

      get selectedBoutique() {
        return this.$store.clickCollect?.selectedBoutique;
      },

      get unavailableSkus() {
        return this.$store.clickCollect?.unavailableSkus || [];
      },

      get isClickAndCollect() {
        return this.deliveryMethod === 'click_and_collect';
      },

      formatBoutiqueName(name) {
        if (!name) return '';
        const idx = name.indexOf(': ');
        return idx !== -1 ? name.slice(idx + 2) : name;
      },

      get selectedBoutiqueLabel() {
        const boutique = this.selectedBoutique;
        if (!boutique) return '';
        const name = this.formatBoutiqueName(boutique.name);
        const eta = boutique.etaFormatted || boutique.eta || '';
        return `Collect in-store from ${name}${eta ? ` ${eta}` : ''}`;
      },

      selectDelivery() {
        this.$store.clickCollect?.setDeliveryMethod('delivery');
      },

      selectClickAndCollect() {
        this.$store.clickCollect?.setDeliveryMethod('click_and_collect');

        const skus = this.$store.cart?.items?.map((item) => item.sku).filter(Boolean) || [];
        window.dispatchEvent(new CustomEvent('click-collect:open', {
          detail: { mode: 'cart', skus },
        }));
      },

      getUnavailableItemTitles() {
        const cartItems = this.$store.cart?.items || [];
        return cartItems
          .filter((item) => this.unavailableSkus.includes(item.sku))
          .map((item) => item.product_title || item.title || item.sku);
      },
    };
  },
};
